import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Clock, CreditCard, Lock } from 'lucide-react';
export function PricingSection() {
  const [selectedOffer, setSelectedOffer] = useState<'pro' | 'elite'>('elite');
  const handleCheckout = () => {
    const url = selectedOffer === 'elite' ? 'https://checkout.empezahoy.shop/cart/48214721265896:1' : 'https://checkout.empezahoy.shop/cart/48214719070440:1';
    window.location.href = url;
  };
  return <section id="pricing" className="py-12 md:py-24 px-4 relative bg-mystic-900" data-id="element-97">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-98">
        <div className="absolute top-[20%] left-[-10%] w-[500px] h-[500px] bg-mystic-700/30 rounded-full mix-blend-screen filter blur-[100px]" data-id="element-99"></div>
        <div className="absolute bottom-[10%] right-[-10%] w-[600px] h-[600px] bg-gold-dark/10 rounded-full mix-blend-screen filter blur-[120px]" data-id="element-100"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-101">
        <div className="text-center mb-8 md:mb-12" data-id="element-102">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold mb-2 md:mb-4" data-id="element-103">
            Elegí tu pack
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-xl text-gold-light" data-id="element-104">
            Acceso inmediato a todos los recursos
          </motion.p>
        </div>

        <div className="flex flex-col gap-4 md:gap-6 mb-8" data-id="element-105">
          {/* Offer 1: Sistema Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedOffer('pro')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 flex items-center ${selectedOffer === 'pro' ? 'border-gold bg-mystic-800/80 shadow-[0_0_30px_rgba(212,168,83,0.15)]' : 'border-mystic-700 bg-mystic-900/50 hover:border-mystic-600'}`} data-id="element-106">
            <div className="flex flex-row items-center w-full" data-id="element-107">
              <div className="flex items-center gap-3 md:gap-4 flex-1" data-id="element-108">
                {/* Radio */}
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-109">
                  {selectedOffer === 'pro' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-110"></div>}
                </div>
                {/* Text */}
                <div data-id="element-111">
                  <div className="flex items-center gap-2 mb-0.5 md:mb-1" data-id="element-112">
                    <span className="text-lg md:text-xl" data-id="element-113">📘</span>
                    <h3 className="text-base md:text-xl font-bold text-white uppercase tracking-wide" data-id="element-114">
                      Sistema Pro
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-gray-400" data-id="element-115">
                    6 tomos + 6 bonos
                  </p>
                </div>
              </div>
              {/* Price */}
              <div className="text-right ml-4 shrink-0" data-id="element-116">
                <span className="text-gray-500 line-through text-xs md:text-sm block" data-id="element-117">
                  $39.990
                </span>
                <span className="text-xl md:text-3xl font-bold text-white" data-id="element-118">
                  $19.990
                </span>
              </div>
            </div>
          </motion.div>

          {/* Offer 2: Registros Akashicos Élite */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelectedOffer('elite')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 flex items-center ${selectedOffer === 'elite' ? 'border-gold bg-mystic-800/80 shadow-[0_0_30px_rgba(212,168,83,0.15)]' : 'border-mystic-700 bg-mystic-900/50 hover:border-mystic-600'}`} data-id="element-119">
            <div className="flex flex-row items-center w-full" data-id="element-120">
              <div className="flex items-start md:items-center gap-3 md:gap-4 flex-1" data-id="element-121">
                {/* Radio */}
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center shrink-0 mt-1 md:mt-0 ${selectedOffer === 'elite' ? 'border-gold' : 'border-gray-500'}`} data-id="element-122">
                  {selectedOffer === 'elite' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-123"></div>}
                </div>
                {/* Text */}
                <div data-id="element-124">
                  <div className="flex items-center gap-2 mb-1 md:mb-1.5 flex-wrap" data-id="element-125">
                    <span className="text-lg md:text-xl" data-id="element-126">🏆</span>
                    <h3 className="text-base md:text-xl font-bold text-white uppercase tracking-wide" data-id="element-127">
                      Registros Akáshicos Élite
                    </h3>
                  </div>
                  <div className="flex flex-wrap items-center gap-2 mb-1.5 md:mb-2" data-id="element-128">
                    <span className="bg-gold text-mystic-900 text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-129">
                      ⭐ Más Elegido
                    </span>
                    <span className="bg-green-900/50 text-green-400 border border-green-800 text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-130">
                      Ahorrás $7.000
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-gray-400" data-id="element-131">
                    Todo el Sistema Pro + 2 Upsells PRO
                  </p>
                </div>
              </div>
              {/* Price */}
              <div className="text-right ml-4 shrink-0 self-center" data-id="element-132">
                <span className="text-gray-500 line-through text-xs md:text-sm block" data-id="element-133">
                  $59.990
                </span>
                <span className="text-xl md:text-3xl font-bold text-gold" data-id="element-134">
                  $27.990
                </span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-center" data-id="element-135">
          <Button onClick={handleCheckout} fullWidth className="py-4 md:py-5 text-lg md:text-xl font-bold shadow-[0_0_20px_rgba(212,168,83,0.3)] mb-4" data-id="element-136">
            SÍ, QUIERO MI SISTEMA →
          </Button>
          <p className="text-gray-400 text-sm italic mb-8" data-id="element-137">
            La opción más elegida por facilitadoras profesionales
          </p>
        </motion.div>

        {/* Dynamic Details Module */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-mystic-800/50 border border-mystic-700 rounded-2xl p-6 md:p-8 mb-8" data-id="element-138">
          <h4 className="text-gold font-bold mb-4 md:mb-6 text-center md:text-left text-lg" data-id="element-139">
            ¿Qué incluye tu selección?
          </h4>
          {selectedOffer === 'pro' ? <ul className="space-y-3 md:space-y-4" data-id="element-140">
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-141">
                <span className="shrink-0 text-lg" data-id="element-142">📕</span>
                <span className="text-gray-200" data-id="element-143">
                  Tomo 1: Base Profesional y Ética
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-144">
                <span className="shrink-0 text-lg" data-id="element-145">📗</span>
                <span className="text-gray-200" data-id="element-146">Tomo 2: Intake PRO</span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-147">
                <span className="shrink-0 text-lg" data-id="element-148">📘</span>
                <span className="text-gray-200" data-id="element-149">Tomo 3: Guión de Sesión</span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-150">
                <span className="shrink-0 text-lg" data-id="element-151">📙</span>
                <span className="text-gray-200" data-id="element-152">Tomo 4: Traducción PRO</span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-153">
                <span className="shrink-0 text-lg" data-id="element-154">📔</span>
                <span className="text-gray-200" data-id="element-155">
                  Tomo 5: Informe Post-Sesión
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-156">
                <span className="shrink-0 text-lg" data-id="element-157">📒</span>
                <span className="text-gray-200" data-id="element-158">
                  Tomo 6: Sistema y Flujo de Trabajo
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base mt-4 pt-4 border-t border-mystic-700" data-id="element-159">
                <span className="shrink-0 text-lg" data-id="element-160">🎁</span>
                <span className="text-gold-light" data-id="element-161">
                  Bono 1: Pack de Disclaimers y Acuerdos Listos
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-162">
                <span className="shrink-0 text-lg" data-id="element-163">🎁</span>
                <span className="text-gold-light" data-id="element-164">
                  Bono 2: Banco de Frases y Scripts PRO
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-165">
                <span className="shrink-0 text-lg" data-id="element-166">🎁</span>
                <span className="text-gold-light" data-id="element-167">
                  Bono 3: Kit de Pricing y Paquetes
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-168">
                <span className="shrink-0 text-lg" data-id="element-169">🎁</span>
                <span className="text-gold-light" data-id="element-170">
                  Bono 4: Checklist "Sesión Impecable"
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-171">
                <span className="shrink-0 text-lg" data-id="element-172">🎁</span>
                <span className="text-gold-light" data-id="element-173">
                  Bono 5: Mini Guía de Contenido para Redes
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-174">
                <span className="shrink-0 text-lg" data-id="element-175">🎁</span>
                <span className="text-gold-light" data-id="element-176">
                  Bono 6: FAQ Lista para Instagram o Web
                </span>
              </li>
            </ul> : <ul className="space-y-3 md:space-y-4" data-id="element-177">
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-178">
                <span className="shrink-0 text-lg" data-id="element-179">🏆</span>
                <span className="text-gray-200 font-medium" data-id="element-180">
                  Todo lo del Sistema Pro (6 tomos + 6 bonos)
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base mt-4 pt-4 border-t border-mystic-700" data-id="element-181">
                <span className="shrink-0 text-lg" data-id="element-182">⚡</span>
                <div data-id="element-183">
                  <span className="text-gold-light font-bold block" data-id="element-184">
                    Upsell 1: Kit Comercial PRO
                  </span>
                  <span className="text-gray-400 text-xs" data-id="element-185">
                    Vendé tus sesiones sin perseguir ni justificarte
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base" data-id="element-186">
                <span className="shrink-0 text-lg" data-id="element-187">⚡</span>
                <div data-id="element-188">
                  <span className="text-gold-light font-bold block" data-id="element-189">
                    Upsell 2: Pack Entregables Premium
                  </span>
                  <span className="text-gray-400 text-xs" data-id="element-190">
                    Informes y planes para cobrar más por sesión
                  </span>
                </div>
              </li>
            </ul>}
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="border border-mystic-700 rounded-2xl p-4 md:p-6 bg-mystic-900/50" data-id="element-191">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-gray-400" data-id="element-192">
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-193">
              <Lock className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-194" />
              <span className="text-xs md:text-sm font-medium" data-id="element-195">
                Pago seguro
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-196">
              <Clock className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-197" />
              <span className="text-xs md:text-sm font-medium" data-id="element-198">
                Acceso en 5 min
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-199">
              <Shield className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-200" />
              <span className="text-xs md:text-sm font-medium" data-id="element-201">
                Garantía 7 días
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-202">
              <CreditCard className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-203" />
              <span className="text-xs md:text-sm font-medium" data-id="element-204">
                Mercado Pago
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}